import { useSelector } from 'react-redux'

export function useSpotId(spotName) {
	const { librariesResponse } = useSelector((state) => state.libs)

	// get all available spots
	const spots =
		librariesResponse &&
		librariesResponse.libraries
			.reduce((prevValue, currentValue) => {
				currentValue.spots.forEach((item) => (item.libName = currentValue.library_name))

				return prevValue.concat([currentValue.spots])
			}, [])
			.flat()

	const res = spots && spots.find((spot) => spot.spot === spotName)

	return [res && res.spot_id, res && res.libName]
}

export function getLibNameBySpotId(spotId, librariesResponse) {
	if (!librariesResponse) {
		return 'Spin & Go'
	}

	const { libraries } = librariesResponse
	// get all available spots
	const spots = libraries
		.reduce((prevValue, currentValue) => {
			currentValue.spots.forEach((item) => (item.libName = currentValue.library_name))

			return prevValue.concat([currentValue.spots])
		}, [])
		.flat()

	const res = spots.find((spot) => spot.spot_id === spotId)

	return res.libName
}
